import {
  Box,
  useTheme,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Tooltip,
  Typography,
  IconButton,
  Menu,
  Divider,
  TextField,
  InputAdornment,
  Chip,
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
import Header from "../../../Dashboard/Header";
import React, { useEffect, useState } from "react";
import axios from "axios";
import ShowVoucherDetails from "./ShowVoucherDetails";
import ShowLedDetails from "../Ledger Approval/ShowLedDetails";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TableChartIcon from "@mui/icons-material/TableChart";
import FilterListIcon from "@mui/icons-material/FilterList";
import CheckIcon from "@mui/icons-material/Check";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EventIcon from "@mui/icons-material/Event";
import DownloadIcon from "@mui/icons-material/Download";

// Key for storing user preferences in localStorage
const PREFERENCE_KEY = "infiniteAppUserPreferences";

export default function AdminReport() {
  // State variables
  const [AdminVchs, setVouchers] = useState([]); // Stores voucher data
  const [ledgers, setLedgers] = useState([]); // Stores ledger data
  const [stockItems, setStockItems] = useState([]); // Stores stock item data
  const [selectedData, setSelectedData] = useState("voucher"); // Currently selected data type
  const [loading, setLoading] = useState(false); // Loading state for API calls

  const [openPeriod, setOpenPeriod] = useState(false);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [VchTypes, setVchTypes] = useState([]);

  // Three dots menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  // Search filter state
  const [searchTerm, setSearchTerm] = useState("");
  // Global search state for table data
  const [globalSearchTerm, setGlobalSearchTerm] = useState("");

  // Get authentication token and company ID from localStorage
  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");

  // Pagination and theming
  const [pageSize, setPageSize] = useState(20);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Load saved user preferences from localStorage or use defaults
  const saved = localStorage.getItem(PREFERENCE_KEY);
  const preferences = saved
    ? JSON.parse(saved)
    : {
        rowHeight: 40,
        fontFamily: "Source Sans Pro",
        fontSize: 16,
        tableAlign: "center",
      };

  // ==============================

  const [vchTypeName, setvchTypeName] = useState("");

  const handleVchTypeChange = (value) => {
    setvchTypeName(value);
    fetchData(value);
    handleMenuClose();
  };

  /**
   * Fetches data from the API based on the selected data type
   */

  const fetchData = async (selectedType = vchTypeName) => {
    setLoading(true);
    try {
      if (selectedData === "voucher") {
        // Fetch voucher data
        const response = await axios.post(
          process.env.REACT_APP_API_URL + "/approvalModule/vchAdminReport",
          { cmpid },
          { headers: { Authorization: token } }
        );
        // console.log("vch data", response.data);
        const AdminArrayData = Object.values(response.data);

        // Sort voucher data by voucher number in ascending order initially
        const sortedAdminArrayData = AdminArrayData.sort((a, b) => {
          // Convert voucher numbers to numbers for proper numerical sorting
          const vchNumA = parseInt(a.vch_number) || 0;
          const vchNumB = parseInt(b.vch_number) || 0;
          return vchNumA - vchNumB;
        });

        //  Get unique Vch Type
        const uniqueVchtype = sortedAdminArrayData.filter(
          (item, index, self) =>
            index === self.findIndex((obj) => obj.vch_type === item.vch_type)
        );
        setVchTypes(uniqueVchtype);

        if (!selectedType) {
          setVouchers(sortedAdminArrayData);
        } else {
          const vchtypeFlt = sortedAdminArrayData.filter(
            (row) => row.vch_type === selectedType
          );
          setVouchers(vchtypeFlt);
        }
      } else if (selectedData === "ledger") {
        // Fetch ledger data
        const ledAdminResponse = await axios.post(
          process.env.REACT_APP_API_URL + "/approvalModule/ledAdminReport",
          { cmpid },
          { headers: { Authorization: token } }
        );
        const ledgerArrayData = Object.values(ledAdminResponse.data);
        setLedgers(ledgerArrayData);
        // console.log(ledgerArrayData)
      } else if (selectedData === "stockitem") {
        // Fetch stock item data
        const stkAdminResponse = await axios.post(
          process.env.REACT_APP_API_URL + "/approvalModule/stkAdminReport",
          { cmpid },
          { headers: { Authorization: token } }
        );
        const stockItemArrayData = Object.values(stkAdminResponse.data);
        setStockItems(stockItemArrayData);
        // console.log(stockItemArrayData)
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedData]);

  /**
   * Converts date string from YYYYMMDD format to DD/MM/YYYY format
   * @param {string} dateString - Date string in YYYYMMDD format
   * @returns {string} Formatted date string
   */
  const convertDate = (dateString) => {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return `${day}/${month}/${year}`;
  };

  // Format date for display
  const formatDisplayDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
  };

  // Filter data  initial state
  const [filteredData, setFilteredData] = useState([]); // initial data

  const handleApply = () => {
    let result = AdminVchs;
    // console.log("Original Data", result);

    if (fromDate || toDate) {
      //vchTypeName
      result = result.filter((row) => {
        // Convert row.vch_date (YYYYMMDD) into valid Date
        const dateStr = row.vch_date.toString();
        const rowDate = new Date(
          `${dateStr.substring(0, 4)}-${dateStr.substring(
            4,
            6
          )}-${dateStr.substring(6, 8)}`
        );

        const from = fromDate ? new Date(fromDate) : null;
        const to = toDate ? new Date(toDate) : null;

        if (from && to) return rowDate >= from && rowDate <= to;
        if (from) return rowDate >= from;
        if (to) return rowDate <= to;
        return true;
      });
    } else {
      result = AdminVchs;
    }

    setFilteredData(result);
    setOpenPeriod(false);
  };

  const handleClearDates = () => {
    setFromDate("");
    setToDate("");
    setFilteredData(AdminVchs);
  };

  // Helper function to get status text for voucher data
  const getVoucherStatusText = (vch) => {
    const primaryStatus =
      vch.isPrimary === 1 || vch.isPrimary === 2 ? "Approved" : "Pending";

    let secondaryStatus = "Pending";
    if (vch.isPrimary === 2) {
      secondaryStatus = "Not in use";
    } else if (vch.isSecondary === 1 || vch.isSecondary === 2) {
      secondaryStatus = "Approved";
    } else if (vch.isSecondary === 3) {
      secondaryStatus = "Rejected";
    }

    let optionalStatus = "Pending";
    if (vch.isPrimary === 2 || vch.isSecondary === 2) {
      optionalStatus = "Not in use";
    } else if (vch.isOptional === 0) {
      optionalStatus = "Approved";
    } else if (vch.isOptional === 3) {
      optionalStatus = "Rejected";
    }

    return { primaryStatus, secondaryStatus, optionalStatus };
  };

  // Helper function to get status text for ledger data
  const getLedgerStatusText = (ledger) => {
    const primaryStatus = ledger.isPrimary === 0 ? "Pending" : "Approved";
    const optionalStatus = ledger.isOptional === 0 ? "Approved" : "Pending";
    return { primaryStatus, optionalStatus };
  };

  // Helper function to get status text for stock item data
  const getStockItemStatusText = (stockItem) => {
    const optionalStatus = stockItem.isOptional === 0 ? "Approved" : "Pending";
    return { optionalStatus };
  };

  // Apply global search filter to data
  const applyGlobalSearch = (data, dataType) => {
    if (!globalSearchTerm) return data;

    const searchLower = globalSearchTerm.toLowerCase();

    return data.filter((row) => {
      // Check all basic fields
      const basicMatch = Object.values(row).some(
        (value) => value && value.toString().toLowerCase().includes(searchLower)
      );

      if (basicMatch) return true;

      // Check status fields based on data type
      if (dataType === "voucher") {
        const status = getVoucherStatusText(row);
        return (
          status.primaryStatus.toLowerCase().includes(searchLower) ||
          status.secondaryStatus.toLowerCase().includes(searchLower) ||
          status.optionalStatus.toLowerCase().includes(searchLower)
        );
      } else if (dataType === "ledger") {
        const status = getLedgerStatusText(row);
        return (
          status.primaryStatus.toLowerCase().includes(searchLower) ||
          status.optionalStatus.toLowerCase().includes(searchLower)
        );
      } else if (dataType === "stockitem") {
        const status = getStockItemStatusText(row);
        return status.optionalStatus.toLowerCase().includes(searchLower);
      }

      return false;
    });
  };

  const AdminData = !fromDate && !toDate ? AdminVchs : filteredData;
  const searchedAdminData = applyGlobalSearch(AdminData, "voucher");

  // Transform filtered data for display
  const FilterData = searchedAdminData.map((vch) => {
    const status = getVoucherStatusText(vch);
    return {
      id: vch.vch_id,
      vchDate: convertDate(vch.vch_date),
      partyName: vch.PartyName,
      vchNumber: vch.vch_number,
      vchType: vch.vch_type,
      vchAmount: vch.vch_Amount,
      isPrimary: status.primaryStatus,
      Primary_Approver: vch.Primary_Approver,
      isSecondary: status.secondaryStatus,
      Secondary_Approver: vch.Secondary_Approver,
      isOptional: status.optionalStatus,
      Final_Approver: vch.Final_Approver,
    };
  });

  // Transform ledger data for display in DataGrid
  const LedgerStatusRow = applyGlobalSearch(
    Array.isArray(ledgers) ? ledgers : [],
    "ledger"
  ).map((ledger) => {
    const status = getLedgerStatusText(ledger);
    return {
      id: ledger.led_Id,
      ledName: ledger.led_Name,
      Primary_Approver: ledger.Primary_Approver || "N/A",
      Secondary_Approver: ledger.Secondary_Approver || "N/A",
      isOptional: status.optionalStatus,
      isPrimary: status.primaryStatus,
    };
  });

  // Transform stock item data for display in DataGrid
  const StockItemStatusRow = applyGlobalSearch(
    Array.isArray(stockItems) ? stockItems : [],
    "stockitem"
  ).map((stockItem) => {
    const status = getStockItemStatusText(stockItem);
    return {
      id: stockItem.stkItem_Id,
      stkName: stockItem.stkItem_Name,
      Stkparent: stockItem.stkItem_Parent,
      stkItem_PartNo: stockItem.stkItem_PartNo,
      stkItem_Unit: stockItem.stkItem_Unit,
      isOptional: status.optionalStatus,
    };
  });

  // Column definitions for voucher data table

  const getColumnWidth = (FilterData, field, header) => {
    const maxLength = Math.max(
      ...FilterData.map((r) => (r[field] ? r[field].toString().length : 0)),
      header.length
    );
    return maxLength * 10 + 15;
  };

  const AdminColumns = [
    {
      field: "vchDate",
      headerName: "Date",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FilterData, "vchDate", "Date"),
    },
    {
      field: "partyName",
      headerName: "Particulars",
      headerAlign: "left",
      align: "left",
      width: Math.min(getColumnWidth(FilterData, "partyName", "Particulars"), 250),
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography
            variant="body2"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
            }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "vchType",
      headerName: "Vch Types",
      headerAlign: "left",
      align: "left",
      width: getColumnWidth(FilterData, "vchType", "Vch Types"),
    },
    {
      field: "vchNumber",
      headerName: "Vch No",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FilterData, "vchNumber", "Vch No") + 50,
      sortable: true,
    },
    {
      field: "vchAmount",
      headerName: "Amount",
      headerAlign: "right",
      align: "right",
      width: getColumnWidth(FilterData, "vchAmount", "Amount"),
      sortable: true,
    },
    {
      field: "isPrimary",
      headerName: "Primary",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FilterData, "isPrimary", "Primary"),
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span
            style={{ color: params.value === "Approved" ? "green" : "orange" }}
          >
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "Primary_Approver",
      headerName: "Primary Approver",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FilterData, "Primary_Approver", "Primary Approver"),
    },
    {
      field: "isSecondary",
      headerName: "Secondary",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FilterData, "isSecondary", "Secondary"),
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span
            style={{
              color:
                params.value === "Approved"
                  ? "green"
                  : params.value === "Rejected"
                  ? "red"
                  : params.value === "Not in use"
                  ? "gray"
                  : "orange",
            }}
          >
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "Secondary_Approver",
      headerName: "Secondary Approver",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(
        FilterData,
        "Secondary_Approver",
        "Secondary Approver"
      ),
    },
    {
      field: "isOptional",
      headerName: "Final",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FilterData, "isOptional", "Final"),

      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span
            style={{
              color:
                params.value === "Approved"
                  ? "green"
                  : params.value === "Rejected"
                  ? "red"
                  : params.value === "Not in use"
                  ? "gray"
                  : "orange",
            }}
          >
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "Final_Approver",
      headerName: "Final Approver",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FilterData, "Final_Approver", "Final Approver"),
    },
  ];

  // Column definitions for ledger data table
  const LedgerColumns = [
    {
      field: "ledName",
      headerName: "Ledger Name",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(LedgerStatusRow, "ledName", "Ledger Name"),
    },
    {
      field: "Primary_Approver",
      headerName: "Primary Approver",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(
        LedgerStatusRow,
        "Primary_Approver",
        "Primary Approver"
      ),
    },
    {
      field: "isPrimary",
      headerName: "Primary Status",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(LedgerStatusRow, "isPrimary", "Primary Status"),
      renderCell: (params) => (
        <span style={{ color: params.value === "Approved" ? "green" : "red" }}>
          {params.value}
        </span>
      ),
    },
    {
      field: "Secondary_Approver",
      headerName: "Secondary Approver",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(
        LedgerStatusRow,
        "Secondary_Approver",
        "Secondary Approver"
      ),
    },
    {
      field: "isOptional",
      headerName: "Final Status",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(LedgerStatusRow, "isOptional", "Final Status"),
      renderCell: (params) => (
        <span style={{ color: params.value === "Approved" ? "green" : "red" }}>
          {params.value}
        </span>
      ),
    },
  ];

  //========= code for single ledger data show

  const [open, setOpen] = useState(false);
  const [ledId, setledId] = useState("");

  const handleLedClose = () => setOpen(false);

  const LedShowData = async (id) => {
    setOpen(true);
    setledId(id);
  };

  // Column definitions for stock item data table
  const StockItemColumns = [
    {
      field: "stkName",
      headerName: "Stock Item Name",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(StockItemStatusRow, "stkName", "Stock Item Name"),
    },
    {
      field: "Stkparent",
      headerName: "Parent Name",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(StockItemStatusRow, "Stkparent", "Parent Name"),
    },
    {
      field: "stkItem_PartNo",
      headerName: "Part No.",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(StockItemStatusRow, "stkItem_PartNo", "Part No."),
    },
    {
      field: "stkItem_Unit",
      headerName: "Unit",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(StockItemStatusRow, "stkItem_Unit", "Unit"),
    },
    {
      field: "Primary_Approver",
      headerName: "Primary Approver",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(
        StockItemStatusRow,
        "Primary_Approver",
        "Primary Approver"
      ),
    },
    {
      field: "isOptional",
      headerName: "Status",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(StockItemStatusRow, "isOptional", "Status"),
      renderCell: (params) => (
        <span style={{ color: params.value === "Approved" ? "green" : "red" }}>
          {params.value}
        </span>
      ),
    },
  ];

  // ===============================================

  const [openView, setViewOpen] = useState(false);
  const [vchId, setvchId] = useState("");

  const handleCloseShow = () => setViewOpen(false);

  const handleRowClick = (params) => {
    const id = params.row.id;
    if (selectedData === "voucher") {
      setViewOpen(true);
      setvchId(id);
    } else if (selectedData === "ledger") {
      setOpen(true);
      setledId(id);
    }
  };

  /**
   * Handles changes to the data type selector
   * @param {Object} event - The change event
   */
  const handleDataChange = (value) => {
    setSelectedData(value);
    handleMenuClose();
  };

  // Three dots menu handlers
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSearchTerm(""); // Clear search when menu closes
  };

  // Search filter handlers
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  // Global search handlers
  const handleGlobalSearchChange = (event) => {
    setGlobalSearchTerm(event.target.value);
  };

  const handleClearGlobalSearch = () => {
    setGlobalSearchTerm("");
  };

  // Filter VchTypes based on search term
  const filteredVchTypes = VchTypes.filter((item) =>
    item.vch_type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Get first and last dates for default display
  const getDefaultDateRange = () => {
    if (AdminVchs.length === 0) return { first: "—", last: "—" };

    const dates = AdminVchs.map((vch) => vch.vch_date).sort();
    const firstDate = dates[0] ? convertDate(dates[0]) : "—";
    const lastDate = dates[dates.length - 1]
      ? convertDate(dates[dates.length - 1])
      : "—";

    return { first: firstDate, last: lastDate };
  };

  const defaultDates = getDefaultDateRange();

  // Export to Excel functionality
  const exportToExcel = () => {
    // Get current data based on selected data type
    let dataToExport = [];
    let fileName = "";
    let sheetName = "";

    if (selectedData === "voucher") {
      dataToExport = FilterData;
      fileName = "Voucher_Approval_Report";
      sheetName = "Vouchers";
    } else if (selectedData === "ledger") {
      dataToExport = LedgerStatusRow;
      fileName = "Ledger_Approval_Report";
      sheetName = "Ledgers";
    } else if (selectedData === "stockitem") {
      dataToExport = StockItemStatusRow;
      fileName = "Stock_Item_Approval_Report";
      sheetName = "Stock Items";
    }

    if (dataToExport.length === 0) {
      alert("No data to export!");
      return;
    }

    // Create CSV content
    const headers = Object.keys(dataToExport[0]).filter((key) => key !== "id");
    const csvHeaders = headers.join(",");
    const csvRows = dataToExport.map((row) =>
      headers
        .map((header) => {
          const value = row[header];
          // Handle values that might contain commas by wrapping in quotes
          return typeof value === "string" && value.includes(",")
            ? `"${value}"`
            : value;
        })
        .join(",")
    );

    const csvContent = [csvHeaders, ...csvRows].join("\n");

    // Create and download file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `${fileName}_${new Date().toISOString().split("T")[0]}.csv`
    );
    link.style.visibility = "hidden";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <ShowVoucherDetails
        openView={openView}
        vchId={vchId}
        handleCloseShow={handleCloseShow}
        showApproveButton={false}
        showRejectButton={false}
      />

      {/* ========================= */}
      <ShowLedDetails open={open} ledId={ledId} handleClose={handleLedClose} />

      {/* =============================================== */}

      <Box mt="75px" ml="0px" mr="20px">
        {/* Page header */}
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Header
            title="Approval Admin Report"
            subtitle={
              selectedData === "voucher"
                ? "Voucher Approval List"
                : selectedData === "ledger"
                ? "Ledger Approval List"
                : "Stock Item Approval List"
            }
          />

          {/* Three dots menu and controls */}
          <Box
            mb={1}
            gap={1}
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
          >
            {/* Search Functionality */}
            <TextField
              size="small"
              placeholder="Search..."
              value={globalSearchTerm}
              onChange={handleGlobalSearchChange}
              sx={{
                width: "220px",
                "& .MuiOutlinedInput-root": {
                  height: "35px",
                  fontSize: "14px",
                  "& input": {
                    padding: "8px 12px",
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      sx={{ fontSize: 20, color: "text.secondary" }}
                    />
                  </InputAdornment>
                ),
                endAdornment: globalSearchTerm && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={handleClearGlobalSearch}
                      sx={{ padding: "4px" }}
                    >
                      <ClearIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* Export to Excel Button */}
            <Button
              onClick={exportToExcel}
              startIcon={<DownloadIcon />}
              sx={{
                height: "35px",
                minHeight: "35px",
                minWidth: "auto",
                px: 1.5,

                border: `1px solid ${colors.grey[500]}`,

                color: colors.primary[100],
                backgroundColor: "transparent",

                "&:hover": {
                  backgroundColor: colors.blueAccent[700],
                  border: `1px solid ${colors.grey[400]}`,
                },
              }}
            >
              Export to Excel
            </Button>

            {selectedData === "voucher" && (
              <Box display="flex" alignItems="center" gap={1}>
                {/* Date Filter Button */}
                <Button
                  variant="outlined"
                  startIcon={<EventIcon />}
                  onClick={() => setOpenPeriod(true)}
                  sx={{
                    height: "35px",
                    minHeight: "35px",
                    minWidth: "auto",
                    px: 1.5,
                    borderColor: colors.grey[500],
                    color: colors.primary[100],
                    backgroundColor:
                      fromDate || toDate
                        ? colors.blueAccent[800]
                        : "transparent",
                    "&:hover": {
                      backgroundColor: colors.blueAccent[700],
                      borderColor: colors.grey[400],
                    },
                  }}
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                  >
                    <Typography
                      variant="caption"
                      lineHeight={1}
                      color="inherit"
                    >
                      {fromDate || toDate ? "Custom Range" : "Date Range"}
                    </Typography>
                    <Typography
                      variant="caption"
                      lineHeight={1}
                      color="inherit"
                      fontSize="10px"
                    >
                      {fromDate && toDate
                        ? `${formatDisplayDate(fromDate)} - ${formatDisplayDate(
                            toDate
                          )}`
                        : !fromDate && !toDate
                        ? `${defaultDates.first} - ${defaultDates.last}`
                        : fromDate
                        ? `From ${formatDisplayDate(fromDate)}`
                        : `To ${formatDisplayDate(toDate)}`}
                    </Typography>
                  </Box>
                </Button>

                {/* Clear dates chip when filters are active */}
                {(fromDate || toDate) && (
                  <Chip
                    label="Clear"
                    size="small"
                    onClick={handleClearDates}
                    onDelete={handleClearDates}
                    deleteIcon={<ClearIcon />}
                    sx={{
                      height: "24px",
                      fontSize: "0.75rem",
                      backgroundColor: colors.redAccent
                        ? colors.redAccent[500]
                        : "#f44336",
                      color: "white",
                      "& .MuiChip-deleteIcon": {
                        color: "white",
                        fontSize: "16px",
                        "&:hover": {
                          color: "#ffcdd2",
                        },
                      },
                      "&:hover": {
                        backgroundColor: colors.redAccent
                          ? colors.redAccent[600]
                          : "#d32f2f",
                      },
                    }}
                  />
                )}
              </Box>
            )}

            {/* Three dots menu */}
            <IconButton
              aria-label="more"
              aria-controls={openMenu ? "long-menu" : undefined}
              aria-expanded={openMenu ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleMenuClick}
              sx={{
                color: colors.primary[100],
                "&:hover": {
                  backgroundColor: colors.grey[900],
                },
              }}
            >
              <MoreVertIcon />
            </IconButton>

            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleMenuClose}
              PaperProps={{
                style: {
                  width: "260px",
                },
              }}
            >
              {/* Data Type Selection */}
              <Box px={1.5} py={1}>
                <Typography
                  variant="caption"
                  fontWeight="600"
                  color="text.secondary"
                  display="block"
                  gutterBottom
                >
                  <TableChartIcon
                    sx={{ fontSize: 14, mr: 1, verticalAlign: "text-top" }}
                  />
                  DATA TYPE
                </Typography>
                <MenuItem
                  onClick={() => handleDataChange("voucher")}
                  selected={selectedData === "voucher"}
                  dense
                  sx={{
                    borderRadius: 0.5,
                    minHeight: "32px",
                    "&.Mui-selected": {
                      backgroundColor: colors.blueAccent[700],
                    },
                  }}
                >
                  <CheckIcon
                    sx={{
                      fontSize: 16,
                      mr: 1,
                      visibility:
                        selectedData === "voucher" ? "visible" : "hidden",
                    }}
                  />
                  <Typography variant="body2" fontSize="13px">
                    Vouchers
                  </Typography>
                </MenuItem>

                <MenuItem
                  onClick={() => handleDataChange("ledger")}
                  selected={selectedData === "ledger"}
                  dense
                  sx={{
                    borderRadius: 0.5,
                    minHeight: "32px",
                    "&.Mui-selected": {
                      backgroundColor: colors.blueAccent[700],
                    },
                  }}
                >
                  <CheckIcon
                    sx={{
                      fontSize: 16,
                      mr: 1,
                      visibility:
                        selectedData === "ledger" ? "visible" : "hidden",
                    }}
                  />
                  <Typography variant="body2" fontSize="13px">
                    Ledgers
                  </Typography>
                </MenuItem>

                <MenuItem
                  onClick={() => handleDataChange("stockitem")}
                  selected={selectedData === "stockitem"}
                  dense
                  sx={{
                    borderRadius: 0.5,
                    minHeight: "32px",
                    "&.Mui-selected": {
                      backgroundColor: colors.blueAccent[700],
                    },
                  }}
                >
                  <CheckIcon
                    sx={{
                      fontSize: 16,
                      mr: 1,
                      visibility:
                        selectedData === "stockitem" ? "visible" : "hidden",
                    }}
                  />
                  <Typography variant="body2" fontSize="13px">
                    Stock Items
                  </Typography>
                </MenuItem>
              </Box>

              {/* Voucher Type Filter - Only show when viewing voucher data */}
              {selectedData === "voucher" && (
                <>
                  <Divider sx={{ my: 0.5 }} />
                  <Box px={1.5} py={1}>
                    <Typography
                      variant="caption"
                      fontWeight="600"
                      color="text.secondary"
                      display="block"
                      gutterBottom
                    >
                      <FilterListIcon
                        sx={{ fontSize: 14, mr: 1, verticalAlign: "text-top" }}
                      />
                      VOUCHER TYPE
                    </Typography>

                    {/* Search Filter */}
                    <TextField
                      size="small"
                      placeholder="Search voucher types..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                      sx={{
                        mb: 1,
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                          height: "32px",
                          fontSize: "13px",
                          "& input": {
                            padding: "6px 8px",
                          },
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon
                              sx={{ fontSize: 18, color: "text.secondary" }}
                            />
                          </InputAdornment>
                        ),
                        endAdornment: searchTerm && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={handleClearSearch}
                              sx={{ padding: "4px" }}
                            >
                              <ClearIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    <MenuItem
                      onClick={() => handleVchTypeChange("")}
                      selected={!vchTypeName}
                      dense
                      sx={{
                        borderRadius: 0.5,
                        minHeight: "32px",
                        "&.Mui-selected": {
                          backgroundColor: colors.blueAccent[700],
                        },
                      }}
                    >
                      <CheckIcon
                        sx={{
                          fontSize: 16,
                          mr: 1,
                          visibility: !vchTypeName ? "visible" : "hidden",
                        }}
                      />
                      <Typography variant="body2" fontSize="13px">
                        All Types
                      </Typography>
                    </MenuItem>

                    {filteredVchTypes.length > 0 ? (
                      filteredVchTypes.map((item, index) => (
                        <MenuItem
                          key={index}
                          onClick={() => handleVchTypeChange(item.vch_type)}
                          selected={vchTypeName === item.vch_type}
                          dense
                          sx={{
                            borderRadius: 0.5,
                            minHeight: "32px",
                            "&.Mui-selected": {
                              backgroundColor: colors.blueAccent[700],
                            },
                          }}
                        >
                          <CheckIcon
                            sx={{
                              fontSize: 16,
                              mr: 1,
                              visibility:
                                vchTypeName === item.vch_type
                                  ? "visible"
                                  : "hidden",
                            }}
                          />
                          <Typography variant="body2" fontSize="13px">
                            {item.vch_type}
                          </Typography>
                        </MenuItem>
                      ))
                    ) : (
                      <Box
                        sx={{
                          textAlign: "center",
                          py: 1,
                          color: "text.secondary",
                        }}
                      >
                        <Typography variant="body2" fontSize="13px">
                          No voucher types found
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </>
              )}
            </Menu>
          </Box>
        </Box>

        {/* Main data table */}
        <Box
          height="80vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
              cursor: "pointer",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-row": {
              borderBottom: `1px solid ${colors.grey[700]} !important`,
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
              color: colors.primary[150],
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
              color: colors.primary[150],
            },
            "& .MuiDataGrid-cell:focus": { outline: "none" },
            // Zoom on hover using a class
            "& .admRzoom-row:hover": {
              transform: "scale(1.01)",
              transition: "transform 0.2s ease-in-out",
              zIndex: 1,
              backgroundColor: colors.blueAccent[900],
            },
          }}
        >
          <DataGrid
            rows={
              selectedData === "voucher"
                ? FilterData
                : selectedData === "ledger"
                ? LedgerStatusRow
                : StockItemStatusRow
            }
            columns={
              selectedData === "voucher"
                ? AdminColumns
                : selectedData === "ledger"
                ? LedgerColumns
                : StockItemColumns
            }
            loading={loading}
            disableColumnMenu={false}
            disableColumnFilter
            disableColumnSelector
            onRowClick={handleRowClick}
            getRowClassName={() => "admRzoom-row"}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            rowHeight={25}
            headerHeight={25}
            componentsProps={{
              footer: {
                sx: {
                  height: 25,
                  minHeight: 25,
                },
              },
            }}
            sx={{
              "& .MuiDataGrid-virtualScroller": {
                overflow: "auto",
              },
              // Hide sort icons completely
              "& .MuiDataGrid-menuIcon, & .MuiDataGrid-sortIcon": {
                opacity: 0,
                transition: "opacity 0.2s ease-in-out",
              },
              // Show sort icons only on column header hover
              "& .MuiDataGrid-columnHeader:hover .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader:hover .MuiDataGrid-sortIcon":
                {
                  opacity: 1,
                },
            }}
            initialState={{
              sorting: {
                sortModel: [
                  {
                    field: "vchNumber",
                    sort: "asc",
                  },
                ],
              },
            }}
          />
        </Box>
      </Box>
      {/*Change Period pop Up Code */}

      <Dialog
        open={openPeriod}
        onClose={() => setOpenPeriod(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            pb: 1,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <CalendarTodayIcon color="primary" />
          <Typography variant="h2">Select Date Range</Typography>
        </DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={3} mt={1}>
            <Box>
              <Typography variant="subtitle2" gutterBottom color="primary">
                From Date
              </Typography>
              <TextField
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                size="small"
                fullWidth
                InputProps={{
                  sx: { height: "40px" },
                }}
              />
            </Box>
            <Box>
              <Typography variant="subtitle2" gutterBottom color="primary">
                To Date
              </Typography>
              <TextField
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                size="small"
                fullWidth
                InputProps={{
                  sx: { height: "40px" },
                }}
              />
            </Box>

            {/* Quick date presets */}
            <Box>
              <Typography variant="subtitle2" gutterBottom color="primary">
                Quick Select
              </Typography>
              <Box display="flex" gap={1} flexWrap="wrap">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    const today = new Date();
                    const lastWeek = new Date(today);
                    lastWeek.setDate(today.getDate() - 7);
                    setFromDate(lastWeek.toISOString().split("T")[0]);
                    setToDate(today.toISOString().split("T")[0]);
                  }}
                >
                  Last 7 Days
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    const today = new Date();
                    const lastMonth = new Date(today);
                    lastMonth.setMonth(today.getMonth() - 1);
                    setFromDate(lastMonth.toISOString().split("T")[0]);
                    setToDate(today.toISOString().split("T")[0]);
                  }}
                >
                  Last 30 Days
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    const today = new Date();
                    const firstDay = new Date(
                      today.getFullYear(),
                      today.getMonth(),
                      1
                    );
                    setFromDate(firstDay.toISOString().split("T")[0]);
                    setToDate(today.toISOString().split("T")[0]);
                  }}
                >
                  This Month
                </Button>
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Box flex={1} />
          <Button
            onClick={() => setOpenPeriod(false)}
            sx={{
              backgroundColor: "#c62828",
              color: "white",
              "&:hover": {
                backgroundColor: "#c62828",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleApply}
            variant="contained"
            sx={{
              backgroundColor: "#EFE17C",
              color: "#000000",
              "&:hover": {
                backgroundColor: "#E6D669",
                color: "#000000",
              },
            }}
          >
            Apply Dates
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}